import { useEffect } from "react";
import Lenis from "lenis";
import Header from "./Header";
import Hero from "./Hero";
import PillStrip from "./PillStrip";
import Waitlist from "./Waitlist";
import StartingRange from "./StartingRange";
import Footer from "./Footer";

export default function LandingPage() {
  useEffect(() => {
    if (window.location.hash === "#nosmooth") return;
    const lenis = new Lenis({
      duration: 1.3,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    });

    let rafId;
    function raf(time) {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    }
    rafId = requestAnimationFrame(raf);

    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  useEffect(() => {
    const target = new URLSearchParams(window.location.search).get("scrollTo");
    if (!target) return;
    const t = setTimeout(() => {
      document.getElementById(target)?.scrollIntoView({ behavior: "smooth" });
      window.history.replaceState(null, "", window.location.pathname);
    }, 350);
    return () => clearTimeout(t);
  }, []);

  return (
    <div className="App">
      <Header />
      <main>
        <Hero />
        <PillStrip />
        <section id="waitlist">
          <Waitlist />
        </section>
        <StartingRange />
      </main>
      <Footer />
    </div>
  );
}
